(() => {
  if (matchMedia('(max-width:989px)').matches) return;
  if (window.__sharpChromeElasticEgg20260913) return;
  window.__sharpChromeElasticEgg20260913 = true;

  const ua = navigator.userAgent || '';
  const isChrome = /(Chrome|CriOS)/.test(ua) && !/(Edg|OPR|SamsungBrowser)/.test(ua);
  const isMobileTouch =
    window.matchMedia('(max-width: 989px)').matches &&
    (navigator.maxTouchPoints > 0 || 'ontouchstart' in window);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!isChrome || isMobileTouch) return;

  const setup = () => {
    if (typeof window.__sharpChromeElasticEggCleanup === 'function') {
      window.__sharpChromeElasticEggCleanup();
      window.__sharpChromeElasticEggCleanup = null;
    }

    if (typeof window.__sharpCrossBrowserEggCleanup === 'function') {
      window.__sharpCrossBrowserEggCleanup();
      window.__sharpCrossBrowserEggCleanup = null;
    }

    document.getElementById('sharp-cross-browser-overscroll-style')?.remove();
    document.documentElement.classList.add('sharp-chrome-easter-egg');

    const wrapper = document.querySelector('.header-wrapper');
    const header = wrapper?.querySelector('header') || document.querySelector('header.header');
    const logo = header?.querySelector('.header__heading-logo-wrapper, .header__heading-link');
    const menus = header
      ? [...header.querySelectorAll('.header__inline-menu header-menu > details')]
      : [];
    if (!wrapper || !header || !logo || !menus.length) return;

    let reveal = wrapper.querySelector('.sharp-overscroll-easter-egg');
    if (!reveal) {
      reveal = document.createElement('div');
      reveal.className = 'sharp-overscroll-easter-egg';
      reveal.setAttribute('aria-hidden', 'true');
      reveal.textContent = 'PHILIPPIANS 4:13';
      wrapper.prepend(reveal);
    }

    let style = document.getElementById('sharp-chrome-elastic-egg-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'sharp-chrome-elastic-egg-style';
      style.textContent = `
        html.sharp-chrome-easter-egg,
        html.sharp-chrome-easter-egg body {
          overscroll-behavior-y: contain !important;
        }
        .header-wrapper { overflow: visible !important; }
        html.sharp-chrome-easter-egg .sharp-overscroll-easter-egg {
          position: fixed !important;
          top: var(--sharp-egg-top, 0px) !important;
          left: var(--sharp-egg-left, 50%) !important;
          z-index: 12 !important;
          transform: translate(-50%, calc(-8px + var(--sharp-egg-travel, 0px))) scale(var(--sharp-egg-scale, 1)) !important;
          opacity: var(--sharp-egg-opacity, 0) !important;
          visibility: hidden !important;
          pointer-events: none !important;
          white-space: nowrap !important;
          color: var(--sharp-easter-egg-color, #111) !important;
          mix-blend-mode: normal !important;
          background: transparent !important;
          font-family: var(--font-heading-family, Arial, sans-serif) !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          line-height: 1 !important;
          letter-spacing: .16em !important;
          text-transform: uppercase !important;
          transition:
            opacity 180ms ease,
            transform 300ms cubic-bezier(.22,.61,.36,1),
            visibility 0s linear 300ms !important;
          will-change: opacity, transform;
        }
        html.sharp-chrome-easter-egg .sharp-overscroll-easter-egg.is-pulling {
          visibility: visible !important;
          transition:
            opacity 65ms linear,
            transform 70ms linear,
            visibility 0s linear 0s !important;
        }
        html.sharp-chrome-easter-egg .header__inline-menu header-menu > details > .sharp-mega-menu {
          translate: 0 var(--sharp-egg-gap, 0px);
          transition: translate 300ms cubic-bezier(.22,.61,.36,1);
        }
        html.sharp-chrome-easter-egg .header__inline-menu header-menu > details.sharp-chrome-egg-split > .sharp-mega-menu {
          will-change: translate;
        }
        @media (prefers-reduced-motion: reduce) {
          html.sharp-chrome-easter-egg .sharp-overscroll-easter-egg,
          html.sharp-chrome-easter-egg .header__inline-menu header-menu > details > .sharp-mega-menu {
            transition: none !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    let activeMenu = null;
    let pull = 0;
    let overscrollDistance = 0;
    let gesturePrimed = false;
    let menuOpenedAt = 0;
    let lastWheelAt = -Infinity;
    let releaseTimer = 0;
    let wheelTimer = 0;
    const splitTimers = new WeakMap();
    let wasAtTop = window.scrollY <= 0.25;
    let topReachedAt = wasAtTop ? performance.now() : 0;

    const topSettleMs = 260;
    const menuSettleMs = 240;
    const newGestureGapMs = 220;
    const deadZone = 34;
    const maxPull = 92;

    const getOpenMenu = () =>
      menus.find((details) => details.hasAttribute('open') && details.querySelector(':scope > .sharp-mega-menu')) || null;

    const positionReveal = () => {
      const headerRect = header.getBoundingClientRect();
      const logoRect = logo.getBoundingClientRect();
      reveal.style.setProperty('--sharp-egg-left', `${Math.round(logoRect.left + (logoRect.width / 2))}px`);
      reveal.style.setProperty('--sharp-egg-top', `${Math.round(headerRect.bottom + 4)}px`);
    };

    const clearMenuSplit = (details = activeMenu) => {
      if (!details) return;
      window.clearTimeout(splitTimers.get(details));
      details.style.setProperty('--sharp-egg-gap', '0px');
      const timer = window.setTimeout(() => {
        if (details.style.getPropertyValue('--sharp-egg-gap') !== '0px') return;
        details.classList.remove('sharp-chrome-egg-split');
        details.style.removeProperty('--sharp-egg-gap');
      }, reducedMotion.matches ? 0 : 310);
      splitTimers.set(details, timer);
    };

    const release = () => {
      window.clearTimeout(releaseTimer);
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
      reveal.style.setProperty('--sharp-egg-scale', '1');
      clearMenuSplit();
      pull = 0;
      releaseTimer = window.setTimeout(
        () => reveal.classList.remove('is-pulling'),
        reducedMotion.matches ? 0 : 310
      );
    };

    const resetGesture = () => {
      overscrollDistance = 0;
      gesturePrimed = false;
    };

    const renderPull = (distance, details) => {
      const activeDistance = Math.max(0, distance - deadZone);
      if (activeDistance <= 0) return;

      pull = Math.min(maxPull, Math.pow(activeDistance, 0.82) * 2.2);
      const progress = Math.min(1, pull / 68);
      const eased = 1 - Math.pow(1 - progress, 1.7);
      const opacityProgress = Math.max(0, (progress - 0.16) / 0.84);
      const opacity = reducedMotion.matches
        ? (progress > 0.45 ? 1 : 0)
        : Math.min(1, opacityProgress * 0.94);
      const gap = Math.round(eased * 12);

      activeMenu = details;
      window.clearTimeout(splitTimers.get(details));
      details.classList.add('sharp-chrome-egg-split');
      details.style.setProperty('--sharp-egg-gap', `${gap}px`);
      reveal.classList.add('is-pulling');
      reveal.style.setProperty('--sharp-egg-opacity', String(opacity));
      reveal.style.setProperty('--sharp-egg-travel', `${Math.round(eased * 7)}px`);
      reveal.style.setProperty('--sharp-egg-scale', (1 + (eased * 0.012)).toFixed(3));
    };

    const onMenuToggle = (event) => {
      const details = event.currentTarget;
      resetGesture();
      release();
      lastWheelAt = -Infinity;

      if (details.hasAttribute('open')) {
        activeMenu = details;
        menuOpenedAt = performance.now();
        positionReveal();
        return;
      }

      if (activeMenu === details) activeMenu = null;
      menuOpenedAt = 0;
    };

    const onWheel = (event) => {
      const now = performance.now();
      const idleGap = now - lastWheelAt;
      lastWheelAt = now;

      const details = getOpenMenu();
      const atAbsoluteTop = window.scrollY <= 0.25;
      if (!details || !atAbsoluteTop || event.deltaY >= 0) {
        resetGesture();
        if (pull > 0) release();
        return;
      }

      if (activeMenu !== details) {
        if (activeMenu) clearMenuSplit(activeMenu);
        activeMenu = details;
        menuOpenedAt = now;
        resetGesture();
        return;
      }

      const topIsSettled = topReachedAt > 0 && now - topReachedAt >= topSettleMs;
      const menuIsSettled = menuOpenedAt > 0 && now - menuOpenedAt >= menuSettleMs;
      if (!topIsSettled || !menuIsSettled) {
        resetGesture();
        return;
      }

      if (idleGap >= newGestureGapMs) {
        gesturePrimed = true;
        overscrollDistance = 0;
        return;
      }

      if (!gesturePrimed) return;

      overscrollDistance += Math.min(28, Math.max(2, Math.abs(event.deltaY)));
      renderPull(overscrollDistance, details);

      window.clearTimeout(wheelTimer);
      wheelTimer = window.setTimeout(() => {
        resetGesture();
        release();
      }, 190);
    };

    const onScroll = () => {
      positionReveal();
      const atTop = window.scrollY <= 0.25;

      if (atTop && !wasAtTop) {
        topReachedAt = performance.now();
        resetGesture();
      }

      if (!atTop) {
        topReachedAt = 0;
        resetGesture();
        if (pull > 0) release();
      }

      wasAtTop = atTop;
    };

    const onOrientationChange = () => window.setTimeout(positionReveal, 120);

    menus.forEach((details) => details.addEventListener('toggle', onMenuToggle));
    const initiallyOpen = getOpenMenu();
    if (initiallyOpen) {
      activeMenu = initiallyOpen;
      menuOpenedAt = performance.now();
    }

    positionReveal();
    window.addEventListener('wheel', onWheel, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', positionReveal, { passive: true });
    window.addEventListener('orientationchange', onOrientationChange, { passive: true });

    window.__sharpChromeElasticEggCleanup = () => {
      window.clearTimeout(releaseTimer);
      window.clearTimeout(wheelTimer);
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', positionReveal);
      window.removeEventListener('orientationchange', onOrientationChange);
      menus.forEach((details) => {
        window.clearTimeout(splitTimers.get(details));
        details.removeEventListener('toggle', onMenuToggle);
        details.classList.remove('sharp-chrome-egg-split');
        details.style.removeProperty('--sharp-egg-gap');
      });
      reveal.classList.remove('is-pulling');
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
      reveal.style.setProperty('--sharp-egg-scale', '1');
    };
  };

  const scheduleSetup = () => {
    window.requestAnimationFrame(setup);
    window.setTimeout(setup, 160);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSetup, { once: true });
  } else {
    scheduleSetup();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(setup, 40));
})();
